import { useSelector } from 'react-redux'

import { groupSlice, GroupState } from '../slices/useGroupSlice'
import { useGetApiV1GroupsNameByGroupnameQuery } from '../api'
import { authSlice } from '@wellesley/auth'

export type UseGroupProps = {
  groupname: string
}

export const useGroup = ({ groupname }: UseGroupProps) => {
  const isAuth = useSelector(authSlice.selectors.selectIsAuthenticated)
  const { refetch, isError, error } = useGetApiV1GroupsNameByGroupnameQuery(
    { groupname },
    {
      skip: !groupname || !isAuth,
    },
  )

  return {
    error,
    isError,
    isLoading: useSelector((state: { group: GroupState }) =>
      groupSlice.selectors.isLoading(state, groupname),
    ),
    group: useSelector((state: { group: GroupState }) =>
      groupSlice.selectors.group(state, groupname),
    ),
    refetchGroup: refetch,
  }
}
